import { salesPerson } from "./../salesperson/endpoints";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  addStatus,
  addStatusFailed,
  addStatusSuccess,
  addValuation,
  addValuationFailed,
  addValuationSuccess,
  AssignAgent,
  AssignAgentFailed,
  AssignAgentSuccess,
  AssignSalesPerson,
  getrequest,
  requestDetails,
  requestDetailsFailed,
  requestDetailsSuccess,
  requestFailed,
  requestSuccess,
  deleteRequest,
  deleteRequestFailed,
  deleteRequestSuccess,
  approveSellCar,
  approveSellCarFailed,
  approveSellCarSuccess,
} from "./slice";
import * as endpoints from "./endpoints";
import { selectrequestState } from "./selector";
import { request } from "@app/services";

//--------------------Get All Requests-------------------------

function* getrequestSaga(
  action: ReturnType<typeof getrequest>
): Generator<any, void, any> {
  try {
    const { limit, page, search } = action.payload;
    const response = yield call(
      request.get,
      `${endpoints.request}?search=${search}&limit=${limit}&page=${page}`
    );

    // Pick only the `data` array from API response
    yield put(
      requestSuccess({
        data: response.data,
        pagination: response.pagination,
      })
    );
  } catch (error: any) {
    yield put(requestFailed(error));
  }
}

function* requestDetailSaga(
  action: ReturnType<typeof requestDetails>
): Generator<any, void, any> {
  try {
    const { id } = action.payload;
    const response = yield call(
      request.get,
      `${endpoints.requestDetail}/${id}`
    );

    // Pick only the `data` array from API response
    yield put(
      requestDetailsSuccess({
        data: response.data,
      })
    );
  } catch (error: any) {
    yield put(requestDetailsFailed(error));
  }
}

//--------------------Add Request-------------------------
export function* addStatusSaga(
  action: ReturnType<typeof addStatus>
): Generator<any, void, any> {
  try {
    const requestState = yield select(selectrequestState);
    const { id, status } = action.payload;

    const formattedStatus = status;

    const response = yield call(
      request.post,
      `/requests/${id}/status`,
      {},
      {
        params: {
          status: formattedStatus,
        },
      }
    );

    if (response?.status) {
      yield put(addStatusSuccess(response.data));

      if (Array.isArray(requestState.data)) {
        const newRequests = requestState.data.map((req: any) =>
          req.id === id ? { ...req, ...response.data } : req
        );
        yield put(requestSuccess(newRequests));
      }
    }
  } catch (error: any) {
    console.error("Update status error:", error);
    yield put(addStatusFailed(error));
  }
}

export function* addValuationSaga(
  action: ReturnType<typeof addValuation>
): Generator<any, void, any> {
  try {
    const requestState = yield select(selectrequestState);
    const { id, valuation } = action.payload;

    const response = yield call(
      request.put,
      `/requests/set-car-valuation/${id}`,
      {},
      {
        params: {
          valuation: valuation,
        },
      }
    );
  } catch (error: any) {
    console.error("Add valuation error:", error);
    yield put(addValuationFailed(error.response?.data || error.message));
  }
}

export function* assignSalesPersonSaga(
  action: ReturnType<typeof addValuation>
): Generator<any, void, any> {
  try {
    const { id, salesPersonId } = action.payload;

    const response = yield call(
      request.post,
      `/requests/${id}/assign-sales-person`,
      {},
      {
        params: {
          salesPersonId,
        },
      }
    );

    if (response?.status) {
      yield put(addValuationSuccess(response.data));
    }
  } catch (error: any) {
    yield put(addValuationFailed(error.response?.data || error.message));
  }
}

export function* assignAgentSaga(
  action: ReturnType<typeof addValuation>
): Generator<any, void, any> {
  try {
    const { id, salesPersonId } = action.payload;

    const response = yield call(
      request.post,
      `/requests/${id}/assign-agent`,
      {},
      {
        params: {
          salesPersonId,
        },
      }
    );

    if (response?.status) {
      yield put(AssignAgentSuccess(response.data));
    }
  } catch (error: any) {
    yield put(AssignAgentFailed(error.response?.data || error.message));
  }
}
export function* approveSellCarSaga(
  action: ReturnType<typeof approveSellCar>
): Generator<any, void, any> {
  try {
    const { id } = action.payload;

    const response = yield call(
      request.post,
      `/requests/${id}/approve-sell-car`,
      {}
    );

    yield put(approveSellCarSuccess(response?.data || response));
    yield put(requestDetails({ id }));
  } catch (error: any) {
    console.error("Approve sell car error:", error);
    yield put(approveSellCarFailed(error.response?.data || error.message || error));
  }
}

export function* deleteRequestSaga(
  action: ReturnType<typeof deleteRequest>
): Generator<any, void, any> {
  try {
    const { id } = action.payload;

    const response = yield call(
      request.delete,
      `${endpoints.request}/${id}`
    );

    yield put(deleteRequestSuccess(response?.data || response));

    const requestState = yield select(selectrequestState);
    if (requestState?.data) {
      if (Array.isArray(requestState.data?.data)) {
        const filteredData = requestState.data.data.filter(
          (req: any) => req.id !== id
        );
        yield put(
          requestSuccess({
            ...requestState.data,
            data: filteredData,
          })
        );
      } else if (Array.isArray(requestState.data)) {
        const filteredData = requestState.data.filter(
          (req: any) => req.id !== id
        );
        yield put(requestSuccess(filteredData));
      }
    }
  } catch (error: any) {
    console.error("Delete request error:", error);
    yield put(
      deleteRequestFailed(error.response?.data || error.message || error)
    );
  }
}

function* requestSagas(): Generator {
  yield all([
    takeLatest(getrequest.type, getrequestSaga),
    takeLatest(addStatus.type, addStatusSaga),
    takeLatest(addValuation.type, addValuationSaga),
    takeLatest(requestDetails.type, requestDetailSaga),
    takeLatest(AssignSalesPerson.type, assignSalesPersonSaga),
    takeLatest(AssignAgent.type, assignAgentSaga),
    takeLatest(approveSellCar.type, approveSellCarSaga),
    takeLatest(deleteRequest.type, deleteRequestSaga),
  ]);
}
export { requestSagas };
